// @core/api/endpoints/payment/batch_get_entity_payments.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BatchGetEntityPaymentsRequest,
  BatchGetEntityPaymentsResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Batch get entity payments
 * Returns payment aspect data for multiple entities. Used by BFF for list views with payment status.
 */
export async function BatchGetEntityPayments(
  data: BatchGetEntityPaymentsRequest,
  options?: RequestOptions
): Promise<BatchGetEntityPaymentsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payment/batch`;
  const requestOptions = options;
  return client.post<BatchGetEntityPaymentsResponse>(requestPath, data, requestOptions);
}
